export const SaturatedR22MixTemperature = [
    [0.3749,213.15,0.6833,0.537,-21.57,203.67,-21.55,223.81,-0.0964,1.0547],
    [0.6451,223.15,0.6966,0.3239,-10.89,207.7,-10.85,228.6,-0.0474,1.0256],
    [0.829,228.15,0.7037,0.2564,-5.5,209.7,-5.44,230.95,-0.0235,1.0126],
    [1.0522,233.15,0.7109,0.2052,-0.07,211.68,0,233.27,0,1.0005],
    [1.2627,237.15,0.7169,0.173,4.29,213.25,4.38,235.09,0.0186,0.9914],
    [1.5049,241.15,0.7231,0.1468,8.68,214.8,8.79,236.89,0.0369,0.9828],
    [1.6389,243.15,0.7262,0.1355,10.88,215.58,11,237.78,0.046,0.9787],
    [1.7819,245.15,0.7294,0.1252,13.09,216.34,13.22,238.66,0.0551,0.9746],
    [1.9345,247.15,0.7327,0.1159,15.31,217.11,15.45,239.53,0.0641,0.9707],
    [2.2698,251.15,0.7393,0.0997,19.76,218.62,19.92,241.24,0.0819,0.9631],
    [2.4534,253.15,0.7427,0.0926,21.99,219.37,22.17,242.09,0.0908,0.9595],
    [2.6482,255.15,0.7462,0.0861,24.23,220.11,24.43,242.92,0.0996,0.9559],
    [2.8547,257.15,0.7497,0.0802,26.48,220.85,26.69,243.74,0.1084,0.9525],
    [3.0733,259.15,0.7533,0.0748,28.73,221.58,28.97,244.56,0.1171,0.949],
    [3.3044,261.15,0.7569,0.0698,31,222.3,31.25,245.36,0.1258,0.9457],
    [3.5485,263.15,0.7606,0.0652,33.27,223.02,33.54,246.15,0.1345,0.9424],
    [3.8062,265.15,0.7644,0.061,35.54,223.73,35.83,246.93,0.1431,0.9392],
    [4.0777,267.15,0.7683,0.0571,37.83,224.43,38.14,247.7,0.1517,0.9361],
    [4.3638,269.15,0.7722,0.0535,40.12,225.13,40.46,248.45,0.1602,0.933],
    [4.6647,271.15,0.7762,0.0501,42.42,225.82,42.78,249.2,0.1688,0.93],
    [4.9811,273.15,0.7803,0.047,44.73,226.5,45.12,249.92,0.1773,0.9271],
    [5.3133,275.15,0.7844,0.0442,47.04,227.17,47.46,250.64,0.1857,0.9241],
    [5.6619,277.15,0.7887,0.0415,49.37,227.83,49.82,251.34,0.1941,0.9213],
    [6.0275,279.15,0.793,0.0391,51.71,228.48,52.18,252.03,0.2025,0.9184],
    [6.4105,281.15,0.7974,0.0368,54.05,229.13,54.56,252.7,0.2109,0.9157],
    [6.8113,283.15,0.802,0.0346,56.4,229.76,56.95,253.35,0.2193,0.9129],
    [7.2307,285.15,0.8066,0.0326,58.77,230.38,59.35,253.99,0.2276,0.9102],
    [8.1268,289.15,0.8162,0.0291,63.53,231.59,64.19,255.21,0.2442,0.9048],
    [9.103,293.15,0.8263,0.0259,68.33,232.76,69.09,256.37,0.2607,0.8996],
    [10.164,297.15,0.8369,0.0232,73.19,233.87,74.04,257.44,0.2772,0.8944],
    [11.313,301.15,0.848,0.0208,78.09,234.92,79.05,258.43,0.2936,0.8893],
    [12.556,305.15,0.8599,0.0186,83.06,235.91,84.14,259.32,0.3101,0.8842],
    [13.897,309.15,0.8724,0.0168,88.08,236.83,89.29,260.11,0.3265,0.879],
    [15.341,313.15,0.8858,0.0151,93.18,237.66,94.53,260.79,0.3429,0.8738],
    [17.298,318.15,0.9039,0.0132,99.65,238.59,101.21,261.46,0.3635,0.8672],
    [19.433,323.15,0.9238,0.0116,106.26,239.34,108.06,261.9,0.3842,0.8603],
    [24.281,333.15,0.9705,0.0089,120,240.24,122.35,261.96,0.4264,0.8455],
];

export const SaturatedR22MixPressure = [
    [0.4,214.29,0.6847,0.5056,-20.36,204.13,-20.34,224.36,-0.0907,1.0512],
    [0.5,218.32,0.6901,0.4107,-16.07,205.76,-16.03,226.3,-0.0709,1.0391],
    [0.6,221.75,0.6947,0.3466,-12.39,207.14,-12.35,227.93,-0.0542,1.0294],
    [0.7,224.75,0.6989,0.3002,-9.17,208.34,-9.12,229.35,-0.0397,1.0213],
    [0.8,227.42,0.7026,0.265,-6.28,209.41,-6.23,230.61,-0.027,1.0144],
    [0.9,229.85,0.7061,0.2374,-3.66,210.37,-3.6,231.74,-0.0155,1.0084],
    [1,232.06,0.7093,0.2152,-1.26,211.25,-1.19,232.77,-0.0051,1.0031],
    [1.25,236.92,0.7166,0.1746,4.04,213.16,4.13,234.99,0.0175,0.9919],
    [1.5,241.07,0.723,0.1472,8.6,214.77,8.7,236.86,0.0366,0.983],
    [1.75,244.71,0.7287,0.1274,12.61,216.18,12.74,238.47,0.0531,0.9755],
    [2,247.97,0.734,0.1123,16.22,217.42,16.37,239.88,0.0678,0.9691],
    [2.25,250.93,0.7389,0.1005,19.51,218.53,19.67,241.15,0.0809,0.9636],
    [2.5,253.64,0.7436,0.091,22.54,219.55,22.72,242.29,0.093,0.9586],
    [2.75,256.15,0.7479,0.0831,25.36,220.48,25.56,243.33,0.104,0.9542],
    [3,258.49,0.7521,0.0765,27.99,221.34,28.22,244.29,0.1143,0.9502],
    [3.25,260.69,0.7561,0.0709,30.47,222.13,30.72,245.18,0.1238,0.9465],
    [3.5,262.76,0.7599,0.0661,32.82,222.88,33.09,246,0.1328,0.9431],
    [3.75,264.72,0.7636,0.0618,35.06,223.58,35.34,246.77,0.1413,0.9399],
    [4,266.59,0.7672,0.0581,37.18,224.24,37.49,247.48,0.1493,0.937],
    [4.25,268.37,0.7706,0.0548,39.22,224.86,39.55,248.16,0.1569,0.9342],
    [4.5,270.07,0.774,0.0519,41.17,225.45,41.52,248.8,0.1642,0.9316],
    [4.75,271.7,0.7773,0.0492,43.05,226,43.42,249.4,0.1711,0.9292],
    [5,273.27,0.7805,0.0469,44.86,226.54,45.25,249.97,0.1777,0.9269],
    [5.25,274.78,0.7836,0.0447,46.61,227.04,47.02,250.51,0.1841,0.9247],
    [5.5,276.23,0.7867,0.0427,48.3,227.53,48.74,251.02,0.1903,0.9226],
    [5.75,277.64,0.7897,0.0409,49.94,227.99,50.4,251.51,0.1962,0.9206],
    [6,279,0.7927,0.0392,51.53,228.44,52.01,251.98,0.2019,0.9186],
    [7,284.06,0.8041,0.0337,57.48,230.04,58.04,253.64,0.2231,0.9117],
    [8,288.6,0.8149,0.0295,62.88,231.43,63.53,255.05,0.2419,0.9056],
    [9,292.74,0.8252,0.0262,67.84,232.64,68.59,256.25,0.2591,0.9001],
    [10,296.55,0.8352,0.0236,72.46,233.71,73.3,257.28,0.2748,0.8952],
    [12,303.4,0.8546,0.0195,80.87,235.48,81.9,258.94,0.3029,0.8864],
    [14,309.44,0.8734,0.0166,88.45,236.89,89.68,260.16,0.3277,0.8786],
    [16,314.88,0.8919,0.0144,95.41,238,96.83,261.04,0.35,0.8715],
    [18,319.84,0.9104,0.0127,101.87,238.86,103.51,261.64,0.3705,0.8649],
    [20,324.41,0.9291,0.0112,107.95,239.51,109.81,261.98,0.3895,0.8586],
    [24,332.61,0.9677,0.0091,119.24,240.22,121.56,261.99,0.4241,0.8463],
];

export const SubcooledR22 = [

];

export const SuperheatedR22 = [
    [0.4,214.29,0.50559,204.13,224.36,1.0512],
    [0.4,218.15,0.51532,205.92,226.53,1.0612],
    [0.4,223.15,0.52787,208.26,229.38,1.0741],
    [0.4,228.15,0.54037,210.63,232.24,1.0868],
    [0.4,233.15,0.55284,213.02,235.13,1.0993],
    [0.4,238.15,0.56526,215.43,238.05,1.1117],
    [0.4,243.15,0.57766,217.88,240.99,1.1239],
    [0.4,248.15,0.59002,220.35,243.95,1.136],
    [0.4,253.15,0.60236,222.85,246.95,1.1479],
    [0.4,258.15,0.61468,225.38,249.97,1.1597],
    [0.4,263.15,0.62697,227.93,253.01,1.1714],
    [0.4,268.15,0.63925,230.52,256.09,1.183],
    [0.4,273.15,0.65151,233.13,259.19,1.1944],
    [0.6,221.75,0.34656,207.14,227.93,1.0294],
    [0.6,223.15,0.34895,207.8,228.74,1.033],
    [0.6,228.15,0.35747,210.2,231.65,1.0459],
    [0.6,233.15,0.36594,212.62,234.58,1.0586],
    [0.6,238.15,0.37437,215.06,237.52,1.0711],
    [0.6,243.15,0.38277,217.53,240.49,1.0835],
    [0.6,248.15,0.39114,220.02,243.49,1.0956],
    [0.6,253.15,0.39948,222.54,246.51,1.1077],
    [0.6,258.15,0.40779,225.08,249.55,1.1196],
    [0.6,263.15,0.41608,227.65,252.62,1.1314],
    [0.6,268.15,0.42436,230.25,255.71,1.143],
    [0.6,273.15,0.43261,232.88,258.83,1.1545],
    [0.8,227.42,0.26503,209.41,230.61,1.0144],
    [0.8,228.15,0.26597,209.76,231.04,1.0163],
    [0.8,233.15,0.27245,212.21,234.01,1.0292],
    [0.8,238.15,0.2789,214.68,236.99,1.0418],
    [0.8,243.15,0.2853,217.17,239.99,1.0543],
    [0.8,248.15,0.29167,219.68,243.02,1.0666],
    [0.8,253.15,0.29801,222.22,246.06,1.0788],
    [0.8,258.15,0.30433,224.78,249.13,1.0908],
    [0.8,263.15,0.31062,227.37,252.22,1.1026],
    [0.8,268.15,0.3169,229.98,255.34,1.1143],
    [0.8,273.15,0.32315,232.62,258.47,1.1259],
    [0.8,278.15,0.32939,235.29,261.64,1.1374],
    [0.8,283.15,0.33561,237.98,264.83,1.1488],
    [1,232.06,0.21518,211.25,232.77,1.0031],
    [1,233.15,0.21633,211.79,233.42,1.0059],
    [1,238.15,0.22158,214.29,236.44,1.0187],
    [1,243.15,0.22679,216.8,239.48,1.0313],
    [1,248.15,0.23197,219.34,242.54,1.0438],
    [1,253.15,0.23712,221.9,245.61,1.056],
    [1,258.15,0.24224,224.48,248.7,1.0681],
    [1,263.15,0.24734,227.08,251.82,1.0801],
    [1,268.15,0.25241,229.71,254.95,1.0919],
    [1,273.15,0.25747,232.36,258.11,1.1035],
    [1,278.15,0.26251,235.04,261.29,1.1151],
    [1,283.15,0.26753,237.74,264.5,1.1265],
    [1.5,241.07,0.14721,214.77,236.86,0.983],
    [1.5,243.15,0.14872,215.85,238.16,0.9883],
    [1.5,248.15,0.15232,218.45,241.3,1.0011],
    [1.5,253.15,0.15588,221.07,244.45,1.0137],
    [1.5,258.15,0.15941,223.7,247.61,1.026],
    [1.5,263.15,0.16292,226.35,250.78,1.0382],
    [1.5,268.15,0.1664,229.02,253.98,1.0502],
    [1.5,273.15,0.16987,231.7,257.18,1.0621],
    [1.5,278.15,0.17331,234.42,260.41,1.0738],
    [1.5,283.15,0.17674,237.15,263.66,1.0854],
    [1.5,288.15,0.18015,239.91,266.93,1.0968],
    [1.5,293.15,0.18355,242.69,270.22,1.1081],
    [1.5,298.15,0.18693,245.49,273.53,1.1193],
    [2,247.97,0.11232,217.42,239.88,0.9691],
    [2,248.15,0.11242,217.51,240,0.9696],
    [2,253.15,0.1152,220.19,243.23,0.9825],
    [2,258.15,0.11795,222.88,246.47,0.9952],
    [2,263.15,0.12067,225.58,249.72,1.0076],
    [2,268.15,0.12336,228.3,252.97,1.0199],
    [2,273.15,0.12603,231.03,256.23,1.031],
    [2,278.15,0.12868,233.78,259.51,1.0438],
    [2,283.15,0.13132,236.54,262.81,1.0555],
    [2,288.15,0.13393,239.33,266.12,1.0671],
    [2,293.15,0.13653,242.14,269.44,1.0786],
    [2,298.15,0.13912,244.97,272.79,1.0899],
    [2.5,253.64,0.09097,219.55,242.29,0.9586],
    [2.5,258.15,0.09303,222.03,245.29,0.9703],
    [2.5,263.15,0.09528,224.79,248.61,0.9831],
    [2.5,268.15,0.09751,227.55,251.93,0.9956],
    [2.5,273.15,0.09971,230.33,255.26,1.0078],
    [2.5,278.15,0.10189,233.12,258.59,1.0199],
    [2.5,283.15,0.10405,235.92,261.93,1.0318],
    [2.5,288.15,0.10619,238.74,265.29,1.0436],
    [2.5,293.15,0.10831,241.58,268.66,1.0552],
    [2.5,298.15,0.11043,244.44,272.04,1.0666],
    [2.5,303.15,0.11253,247.31,275.44,1.0779],
    [2.5,308.15,0.11461,250.21,278.86,1.0891],
    [2.5,313.15,0.11669,253.13,282.3,1.1002],
    [3,258.49,0.07651,221.34,244.29,0.9502],
    [3,263.15,0.07833,223.96,247.46,0.9623],
    [3,268.15,0.08025,226.78,250.86,0.9751],
    [3,273.15,0.08214,229.61,254.25,0.9876],
    [3,278.15,0.084,232.44,257.64,0.9999],
    [3,283.15,0.08585,235.28,261.04,1.012],
    [3,288.15,0.08767,238.14,264.44,1.0239],
    [3,293.15,0.08949,241.01,267.85,1.0357],
    [3,298.15,0.09128,243.89,271.28,1.0472],
    [3,303.15,0.09307,246.8,274.72,1.0587],
    [3,308.15,0.09484,249.72,278.17,1.07],
    [3,313.15,0.0966,252.66,281.64,1.0811],
    [3.5,262.76,0.06605,222.88,246,0.9431],
    [3.5,263.15,0.06619,223.1,246.27,0.9441],
    [3.5,268.15,0.06789,225.99,249.75,0.9572],
    [3.5,273.15,0.06956,228.86,253.21,0.97],
    [3.5,278.15,0.07121,231.74,256.67,0.9825],
    [3.5,283.15,0.07284,234.63,260.12,0.9948],
    [3.5,288.15,0.07444,237.52,263.57,1.0069],
    [3.5,293.15,0.07603,240.42,267.03,1.0188],
    [3.5,298.15,0.0776,243.34,270.5,1.0305],
    [3.5,303.15,0.07916,246.27,273.97,1.0421],
    [3.5,308.15,0.0807,249.22,227.46,1.0535],
    [3.5,313.15,0.08224,252.18,280.97,1.0648],
    [3.5,318.15,0.08376,255.17,284.48,1.0759],
    [4,266.59,0.05812,224.24,247.48,0.937],
    [4,268.15,0.0586,225.16,248.6,0.9411],
    [4,273.15,0.06011,228.09,252.14,0.9542],
    [4,278.15,0.0616,231.02,225.66,0.967],
    [4,283.15,0.06306,233.95,259.18,0.9795],
    [4,288.15,0.0645,236.89,262.69,0.9918],
    [4,293.15,0.06592,239.83,266.19,1.0039],
    [4,298.15,0.06733,242.77,269.71,1.0158],
    [4,303.15,0.06872,245.73,273.22,1.0274],
    [4,308.15,0.0701,248.71,276.75,1.039],
    [4,313.15,0.07146,251.7,280.28,1.0504],
    [4,318.15,0.07282,254.7,283.83,1.0616],
    [4.5,270.07,0.05189,225.45,248.8,0.9316],
    [4.5,273.15,0.05275,227.29,251.03,0.9399],
    [4.5,278.15,0.05411,230.28,254.63,0.9529],
    [4.5,283.15,0.05545,233.26,258.21,0.9657],
    [4.5,288.15,0.05676,236.24,261.78,0.9782],
    [4.5,293.15,0.05805,239.22,265.34,0.9904],
    [4.5,298.15,0.05933,242.2,268.9,1.0025],
    [4.5,303.15,0.06059,245.19,272.46,1.0143],
    [4.5,308.15,0.06184,248.19,276.02,1.0259],
    [4.5,313.15,0.06308,251.2,279.59,1.0374],
    [4.5,318.15,0.0643,254.23,283.17,1.0488],
    [4.5,323.15,0.06552,257.28,286.76,1.06],
    [4.5,328.15,0.06672,260.34,290.36,1.071],
    [5,273.27,0.04686,226.54,249.97,0.9269],
    [5,278.15,0.0481,229.52,253.57,0.9399],
    [5,283.15,0.04934,232.55,257.22,0.953],
    [5,288.15,0.05056,235.57,260.85,0.9657],
    [5,293.15,0.05175,238.59,264.47,0.9781],
    [5,298.15,0.05293,241.61,268.07,0.9903],
    [5,303.15,0.05409,244.63,271.68,1.0023],
    [5,308.15,0.05523,247.66,275.28,1.0141],
    [5,313.15,0.05636,250.7,278.89,1.0257],
    [5,318.15,0.05748,253.76,282.5,1.0371],
    [5,323.15,0.05859,256.82,286.12,1.0484],
    [5,328.15,0.05969,259.9,289.75,1.0595],
    [5.5,276.23,0.04271,227.53,251.02,0.9226],
    [5.5,278.15,0.04317,228.72,252.46,0.9278],
    [5.5,283.15,0.04433,231.81,256.2,0.9411],
    [5.5,288.15,0.04547,234.89,259.9,0.954],
    [5.5,293.15,0.04658,237.95,263.57,0.9667],
    [5.5,298.15,0.04768,241.01,267.23,0.979],
    [5.5,303.15,0.04875,244.07,270.88,0.9912],
    [5.5,308.15,0.04982,247.13,274.53,1.0031],
    [5.5,313.15,0.05086,250.2,278.17,1.0148],
    [5.5,318.15,0.0519,253.27,281.82,1.0264],
    [5.5,323.15,0.05293,256.36,285.47,1.0378],
    [5.5,328.15,0.05394,259.46,289.13,1.049],
    [5.5,333.15,0.05495,262.58,292.8,1.0601],
    [6,279,0.03923,228.44,251.98,0.9186],
    [6,283.15,0.04015,231.05,255.14,0.9299],
    [6,288.15,0.04122,234.18,258.91,0.9431],
    [6,293.15,0.04227,237.29,262.65,0.956],
    [6,298.15,0.0433,240.39,266.37,0.9685],
    [6,303.15,0.04431,243.49,270.07,0.9808],
    [6,308.15,0.0453,246.58,273.76,0.9929],
    [6,313.15,0.04628,249.68,277.45,1.0048],
    [6,318.15,0.04724,252.78,281.13,1.0164],
    [6,323.15,0.0482,255.9,284.82,1.0279],
    [6,328.15,0.04914,259.02,288.51,1.0393],
    [6,333.15,0.05008,262.15,292.2,1.0504],
    [7,284.06,0.03371,230.04,253.64,0.9117],
    [7,288.15,0.03451,232.7,256.86,0.9229],
    [7,293.15,0.03547,235.92,260.75,0.9363],
    [7,298.15,0.03639,239.12,264.59,0.9493],
    [7,303.15,0.0373,242.29,268.4,0.9619],
    [7,308.15,0.03819,245.46,272.19,0.9743],
    [7,313.15,0.03906,248.62,275.96,0.9865],
    [7,318.15,0.03992,251.78,279.72,0.9984],
    [7,323.15,0.04076,254.94,283.48,1.0101],
    [7,328.15,0.0416,258.11,287.23,1.0216],
    [7,333.15,0.04242,261.29,290.99,1.033],
    [7,338.15,0.04324,264.48,294.75,1.0442],
    [7,343.15,0.04405,267.68,298.51,1.0552],
    [8,288.6,0.02953,231.43,255.05,0.9056],
    [8,293.15,0.03033,234.47,258.74,0.9182],
    [8,298.15,0.03118,237.76,262.7,0.9315],
    [8,303.15,0.03202,241.04,266.66,0.9448],
    [8,308.15,0.03283,244.28,270.54,0.9574],
    [8,313.15,0.03363,247.52,274.42,0.97],
    [8,318.15,0.0344,250.74,278.26,0.9821],
    [8,323.15,0.03517,253.96,282.1,0.9941],
    [8,328.15,0.03592,257.18,285.92,1.0058],
    [8,333.15,0.03667,260.4,289.74,1.0174],
    [8,338.15,0.03741,263.64,293.56,1.0287],
    [8,343.15,0.03814,266.87,297.38,1.04],
    [9,292.74,0.02623,232.64,256.25,0.9001],
    [9,293.15,0.0263,232.92,256.59,0.9013],
    [9,303.15,0.02789,239.73,264.83,0.9289],
    [9,313.15,0.02939,246.37,272.82,0.9549],
    [9,323.15,0.03082,252.95,280.68,0.9795],
    [9,333.15,0.03219,259.49,288.46,1.0033],
    [9,343.15,0.03353,266.04,296.21,1.0262],
    [9,353.15,0.03483,272.62,303.96,1.0484],
    [9,363.15,0.03611,279.23,311.73,1.0701],
    [9,373.15,0.03736,285.9,319.53,1.0913],
    [9,383.15,0.0386,292.63,327.37,1.112],
    [9,393.15,0.03982,299.42,335.26,1.1323],
    [9,403.15,0.04103,306.28,343.21,1.1523],
    [9,413.15,0.04223,313.21,351.22,1.1719],
    [9,423.15,0.04342,320.21,359.29,1.1912],
    [10,296.55,0.02358,233.71,257.28,0.8952],
    [10,303.15,0.02457,238.34,262.91,0.9139],
    [10,313.15,0.02598,245.18,271.17,0.9407],
    [10,323.15,0.02732,251.9,279.22,0.966],
    [10,333.15,0.0286,258.56,287.15,0.9902],
    [10,343.15,0.02984,265.19,295.03,1.0135],
    [10,353.15,0.03104,271.84,302.88,1.0361],
    [10,363.15,0.03221,278.52,310.74,1.058],
    [10,373.15,0.03337,285.24,318.61,1.0794],
    [10,383.15,0.0345,292.02,326.52,1.1003],
    [10,393.15,0.03562,298.85,334.46,1.1207],
    [10,403.15,0.03672,305.74,342.46,1.1408],
    [10,413.15,0.03781,312.7,350.51,1.1605],
    [10,423.15,0.03889,319.74,358.63,1.179],
    [12,303.4,0.01955,235.48,258.94,0.8864],
    [12,313.15,0.02083,242.63,267.62,0.9146],
    [12,323.15,0.02204,249.69,276.14,0.9413],
    [12,333.15,0.02319,256.6,284.43,0.9666],
    [12,343.15,0.02428,263.44,292.58,0.9907],
    [12,353.15,0.02534,270.25,300.66,1.0139],
    [12,363.15,0.02636,277.07,308.7,1.0363],
    [12,373.15,0.02736,283.9,316.73,1.0582],
    [12,383.15,0.02834,290.77,324.78,1.0794],
    [12,393.15,0.0293,297.69,332.85,1.1002],
    [12,403.15,0.03024,304.65,340.95,1.1205],
    [12,413.15,0.03118,311.68,349.09,1.1405],
    [12,423.15,0.0321,318.77,357.29,1.1601],
    [12,433.15,0.03301,325.92,365.54,1.1793],
    [12,443.15,0.03392,333.14,373.84,1.1983],
    [14,309.44,0.01662,236.89,260.16,0.8786],
    [14,313.15,0.01708,239.78,263.7,0.89],
    [14,323.15,0.01823,247.29,272.81,0.9186],
    [14,333.15,0.01929,254.52,281.53,0.9452],
    [14,343.15,0.02029,261.6,290.01,0.9703],
    [14,353.15,0.02125,268.6,298.34,0.9942],
    [14,363.15,0.02217,275.56,306.6,1.0172],
    [14,373.15,0.02306,282.52,314.8,1.0395],
    [14,383.15,0.02393,289.49,323,1.0612],
    [14,393.15,0.02478,296.5,331.19,1.0823],
    [14,403.15,0.02562,303.55,339.41,1.1029],
    [14,413.15,0.02644,310.64,347.65,1.1231],
    [14,423.15,0.02725,317.79,355.94,1.1429],
    [14,433.15,0.02805,324.99,364.26,1.1624],
    [14,443.15,0.02884,332.26,372.64,1.1815],
    [16,314.88,0.0144,238,261.04,0.8715],
    [16,323.15,0.01533,244.66,269.18,0.8971],
    [16,333.15,0.01634,252.29,278.43,0.9252],
    [16,343.15,0.01728,259.65,287.3,0.9515],
    [16,353.15,0.01817,266.86,295.93,0.9762],
    [16,363.15,0.01901,274,304.42,0.9999],
    [16,373.15,0.01983,281.09,312.82,1.0228],
    [16,383.15,0.02062,288.18,321.17,1.0448],
    [16,393.15,0.02139,295.28,329.51,1.0663],
    [16,403.15,0.02214,302.41,337.84,1.0872],
    [16,413.15,0.02288,309.58,346.19,1.1077],
    [16,423.15,0.02361,316.79,354.56,1.1277],
    [16,433.15,0.02432,324.05,362.97,1.1473],
    [16,443.15,0.02503,331.37,371.42,1.1666],
    [18,319.84,0.01265,238.86,261.64,0.8649],
    [18,323.15,0.01301,241.72,265.14,0.8758],
    [18,333.15,0.01401,249.86,275.09,0.9061],
    [18,343.15,0.01492,257.57,284.43,0.9337],
    [18,353.15,0.01576,265.04,293.4,0.9595],
    [18,363.15,0.01655,272.37,302.16,0.9839],
    [18,373.15,0.01731,279.62,310.77,1.0073],
    [18,383.15,0.01804,286.83,319.3,1.0299],
    [18,393.15,0.01874,294.04,327.78,1.0517],
    [18,403.15,0.01943,301.26,336.24,1.073],
    [18,413.15,0.02011,308.5,344.7,1.0937],
    [18,423.15,0.02077,315.78,353.17,1.1139],
    [18,433.15,0.02142,323.1,361.66,1.1338],
    [18,443.15,0.02207,330.47,370.19,1.1532],
    [20,324.41,0.01124,239.51,261.98,0.8586],
    [20,333.15,0.01212,247.2,271.43,0.8873],
    [20,343.15,0.013,255.35,281.36,0.9167],
    [20,353.15,0.01381,263.12,290.74,0.9436],
    [20,363.15,0.01457,270.67,299.8,0.9689],
    [20,373.15,0.01528,278.09,308.65,0.9929],
    [20,383.15,0.01596,285.44,317.37,1.016],
    [20,393.15,0.01663,292.76,326.01,1.0383],
    [20,403.15,0.01727,300.08,334.61,1.0598],
    [20,413.15,0.01789,307.4,343.19,1.0808],
    [20,423.15,0.0185,314.75,351.76,1.1013],
    [20,433.15,0.0191,322.14,360.34,1.1214],
    [20,443.15,0.01969,329.56,368.95,1.141],
    [20,453.15,0.02027,337.03,377.58,1.1603],
    [24,332.61,0.00907,240.22,261.99,0.8463],
    [24,333.15,0.00913,240.78,262.68,0.8484],
    [24,343.15,0.01006,250.3,274.43,0.8831],
    [24,353.15,0.01085,258.89,284.93,0.9133],
    [24,363.15,0.01156,267.01,294.75,0.9407],
    [24,373.15,0.01222,274.85,304.18,0.9663],
    [24,383.15,0.01284,282.53,313.35,0.9906],
    [24,393.15,0.01343,290.11,322.35,1.0137],
    [24,403.15,0.014,297.64,331.25,1.0361],
    [24,413.15,0.01456,305.14,340.08,1.0577],
    [24,423.15,0.01509,312.64,348.87,1.0787],
    [24,433.15,0.01562,320.16,357.64,1.0992],
    [24,443.15,0.01613,327.7,366.41,1.1192],
    [24,453.15,0.01663,335.27,375.2,1.1388],
];
